//css hash: 6048926d38831947 
 export const page = "simple_page--page--DoR8b";
export const header = "simple_page--header--nwyZU";
